module.exports = __webpack_public_path__ + "static/media/33.1919ab74.png";